import {svgIconWrapper} from '../svg-icon-wrapper';

import SquareRegular from './square-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <SquareRegular {...props} />;
}

SvgComponent.iconName = 'squareRegular';

export const SquareRegularIcon = svgIconWrapper(SvgComponent);
